import React, { useState, useCallback, memo } from 'react';

const OfficialInformationComponent = memo(({
  data,
  fields,
  onEdit,
  editIcon = true,
}) => {
  console.log('fields',fields);
  
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleEditClick = useCallback((e) => {
    e.stopPropagation();
    onEdit?.();
  }, [onEdit]);

const renderField = useCallback((field) => {
  const displayLabel =
    field.key === "MobileNo1" && field.label === "Contact Phone"
      ? "Contact No."
      : field.label;

  return (
    <tr key={field.key}>
      <th className="bg-light">{displayLabel}</th>
      <td>{data[field.key] || ""}</td>
    </tr>
  );
}, [data]);


  return (
    <div className="col-md-12 mt-2 p-0">
      <div className="empProfile-accordion">
        <div className="OfficialInfo-header" onClick={toggleAccordion}>
          <h6 className="mb-0 d-flex align-items-center gap-1">
            Other Official Information
            {editIcon && onEdit && (
              <i
                style={{
                  fontSize: "12px",
                  pointerEvents: "none",
                  cursor: "not-allowed",
                  opacity: 0.5,
                }}
                className="bi bi-pencil-square"
                // onClick={handleEditClick}
              ></i>
            )}
          </h6>
          <span className={`arrow-icon ${isOpen ? "open" : ""}`}>
            <i className="bi bi-arrow-down-circle-fill icon-acc"></i>
          </span>
        </div>
        {isOpen && (
          <div className="d-flex flex-column gap-2">
            <div className="OfficialInfo-body">
              <table className="table table-bordered table-hover">
                <tbody className="info-compact-table">
                  {fields.map(renderField)}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default OfficialInformationComponent;